import { useSelector } from 'react-redux'

import type { CheckboxListFilterProps } from '~/components/common/filters/CheckboxListFilter'
import { getInventoryOrdersFilters } from '~/store/duck/inventoryOrders'

import CategoryFilter from '../filters/CategoryFilter'

export interface OrderCategoryFilterProps extends CheckboxListFilterProps {}

const InventoryOrderCategoryFilter = (props: OrderCategoryFilterProps) => {
  const inventoryOrdersFilters = useSelector(getInventoryOrdersFilters)

  return (
    <CategoryFilter
      selectedCategoryFilter={inventoryOrdersFilters?.category}
      {...props}
    />
  )
}

export default InventoryOrderCategoryFilter
